module.exports = __webpack_public_path__ + "static/hollywood-room-2-3e671d73127d1ee24a5a4014779cd402.jpg";